import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { MainHeader } from '@eposnow/ui-core';
import { Card, Button, Typography, useTheme, Box } from '@mui/material';
import { UIContext } from '../../context/UIContext';
import ActionsContainer from '../../components/ActionsContainer';
import { StepContext } from '../../context/StepContext';
import usePageTitle from '../../helperHooks/usePageTitle';

const Welcome = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { goToNextStep } = useContext(StepContext);
  const { isMobile, isTablet } = useContext(UIContext);

  usePageTitle('nav.welcome');

  return (
    <>
      <MainHeader
        title={t(`steps.welcome.header`)}
        styles={{
          marginTop: { xs: 0, sm: 4, md: 1 },
          marginBottom: { xs: 4, sm: 5 },
        }}
        theme={theme}
      >
        <Typography variant="h6">{t(`steps.welcome.description`)}</Typography>
      </MainHeader>
      <Card
        variant="outlined"
        sx={{
          display: 'flex',
          flexDirection: isMobile ? 'column-reverse' : 'row',
          justifyContent: 'space-between',
          flexGrow: 1,
          padding: isMobile ? '2rem' : '3.5rem',
          textAlign: 'center',
          alignItems: 'center',
          marginBottom: '3rem',
          ...((isMobile || isTablet) && {
            marginBottom: '5rem',
          }),
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            textAlign: 'start',
            width: isMobile || isTablet ? '100%' : '50%',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              <Trans i18nKey="screens.welcome.description1" />
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              {t(`screens.welcome.description2`)}
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              {t(`screens.welcome.description3`)}
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              {t(`screens.welcome.description4`)}
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              {t(`screens.welcome.description5`)}
            </Typography>
          </Box>
        </Box>
        {!isMobile && !isTablet && (
          <Box sx={{ width: '50%' }}>
            <img
              src="/static/welcomeScreen.png"
              style={{ maxWidth: '100%', maxHeight: '22rem' }}
              alt={t('screens.welcome.imageAlt')}
            />
          </Box>
        )}
      </Card>
      <ActionsContainer containerSx={{ justifyContent: 'right' }}>
        <Button
          variant="contained"
          sx={{
            margin: '0px',
            flexGrow: '0',
            height: '48px',
          }}
          onClick={goToNextStep}
        >
          {t('actions.next')}
        </Button>
      </ActionsContainer>
    </>
  );
};

export default Welcome;
